module.exports = __webpack_public_path__ + "static/media/logo-header.ce15cf44.png";